module.exports = __webpack_public_path__ + "img/bus_night_down_selected.69ece707.svg";